<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-row class="searchSection">
                <el-form :inline="true" :model="searcheModel" class="demo-form-inline">
                    <DistrictLinkage ref="DistrictLinkage" :provinceId="parseInt(searcheModel.province_id)" :cityId="parseInt(searcheModel.city_id)" :districtId="parseInt(searcheModel.district_id)" @change="changeDistrict"></DistrictLinkage>
                    <el-form-item label="客户名称">
                        <CustomerSelect ref="CustomerSelect" v-model="searcheModel.name" @change="changeObjValue"></CustomerSelect>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch" :loading="loading">搜索
                        </el-button>
                        <el-button @click="resetForm()" size="small">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <div class="main-bd mg20 pro-visible" v-if="info">
                <el-row>
                    <el-col :offset="2">
                        <el-form label-width="200">
                            <el-form-item label="学校ID：" :model="info">
                                {{ info.id }}
                            </el-form-item>
                            <el-form-item label="学校名称：">
                                {{ info.name }}
                            </el-form-item>
                            <el-form-item v-for="(product, index) in info.products" :key="index">
                                <el-row class="searchSection">
                                    <el-col :span="2">
                                        {{product.name}}：
                                    </el-col>
                                    <el-col :span="22">
                                        <div v-if="product.deal_time_str" >
                                            正式订单：{{product.deal_time_str}}
                                        </div>
                                        <div v-if="product.try_out_time_str" >
                                            试用订单：{{product.try_out_time_str}} 
                                            <span v-if="product.product_id == 1 || product.product_id == 2">
                                                ，合作中下载{{product.this_down_info.down_num}}份，学段数：{{product.this_down_info.stage_num}}，科目数：{{product.this_down_info.subject_num}}，账号数：{{product.this_down_info.user_num}}<br>
                                            (一年内：{{product.try_out_order_num}}次试用，总下载：{{product.down_info.down_num}}份，总学段数：{{product.down_info.stage_num}}，总科目数：{{product.down_info.subject_num}}，总账号数：{{product.down_info.user_num}})
                                            </span>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item label="最后跟进时间：">
                                {{ info.last_trace_at }}
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
  </template>
  <style scoped>
  
  </style>
  <script>
  import CustomerService from "~/services/customer";
  import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
  import CustomerSelect from "~/widgets/CustomerSelect.vue";
  export default {
    components: {
        DistrictLinkage,
        CustomerSelect
    },
  
    props: {

    },
  
    data() {
        return {
            loading: false,
            searcheModel: {
                name: '',
                province_id: 0,
                city_id: 0,
                district_id: 0,
            },
            // 分页信息
            info: null,
            fields: [],
            activeName: 'query-info',
        };
    },
  
    created() {
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                name: '',
                province_id: 0,
                city_id: 0,
                district_id: 0,
            };
            this.$refs["DistrictLinkage"].reset();
            this.$refs["CustomerSelect"].reset();
        },

        // 筛选查询
        submitSearch() {
            this.info = null;
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },
        
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            CustomerService.getQueryInfo(params).then((res) => {
                if (res.code == 0) {
                    this.info = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        handleView(row) {
            let path = "/customers/view?id=" + row.customer_id;
            let to = this.$router.resolve({
                path: path
            });
            window.open(to.href, '_blank');
        },

        //业务员姓名远程搜索组件赋值value
        changeObjValue(value) {
            this.searcheModel.name = value.value;
        },

        //地区联动 Cascader 级联选择器,切换事件,表单赋值
        changeDistrict(value) {
            this.searcheModel.province_id = value[0];
            this.searcheModel.city_id = value[1];
            this.searcheModel.district_id = value[2];
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/customer/queryInfo.vue